import { Component, Prop, Element, h } from '@stencil/core';

@Component({
  tag: 'lar-button-group',
  styleUrl: 'button-group.scss',
  shadow: true
})
export class LarvaButtonGroup {
  @Element() el!: HTMLElement;

  render() {
    return (<slot/>);
  }
}
